import React from 'react';
import ReactDOM from 'react-dom/client';
import { SDKProvider } from '@telegram-apps/sdk-react';
import './index.css';
import App from './App';
import WebApp from './WebApp';
import ErrorBoundary from './components/web/ErrorBoundary';

// Если зашли на корень сайта, сразу перекидываем на веб-версию /web/explore
if (typeof window !== 'undefined' && window.location.pathname === '/') {
  window.location.replace('/web/explore');
}

// Check if this is a web app route
const isWebAppRoute = typeof window !== 'undefined' && window.location.pathname.startsWith('/web');

// Safety patch for some embedded browsers where window.location.origin may be "null" or undefined.
if (typeof window !== 'undefined' && typeof window.location !== 'undefined') {
  try {
    const loc = window.location;
    if (!loc.origin || loc.origin === 'null') {
      const patchedOrigin = `${loc.protocol}//${loc.host}`;
      // eslint-disable-next-line no-console
      console.warn('Patching window.location.origin to', patchedOrigin);
      Object.defineProperty(loc, 'origin', {
        configurable: true,
        value: patchedOrigin,
      });
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn('Failed to patch window.location.origin', err);
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));

// Render WebApp for /web/* routes, otherwise render Telegram App
if (isWebAppRoute) {
  root.render(
    <React.StrictMode>
      <ErrorBoundary>
        <WebApp />
      </ErrorBoundary>
    </React.StrictMode>
  );
} else {
  root.render(
    <React.StrictMode>
      <SDKProvider>
        <App />
      </SDKProvider>
    </React.StrictMode>
  );
}

if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .getRegistrations()
    .then((registrations) => {
      registrations.forEach((registration) => registration.unregister());
    })
    .catch((err) => {
      console.warn('Service worker cleanup failed:', err);
    });
}

